import React from "react";
import { Link } from "react-router-dom/cjs/react-router-dom.min";
import { API } from "../../../config";

function WishListCard({
  item,
  isInCart,
  handleCartAction,
  product,
  handleRemoveFromWishlist,
}) {
  return (
    <div
      key={item?.productId}
      className="w-full max-w-[300px] bg-white rounded-lg shadow-md overflow-hidden hover:shadow-lg transition-shadow border-2 border-[#00000051]"
    >
      <div className="relative">
        <img
          src={`${API}/products/photo/${item.productId}`}
          alt={product?.name || "Product"}
          className="w-full h-48 object-contain px-4 py-3"
        />
        <button
          onClick={() => handleRemoveFromWishlist(item.productId)}
          className="absolute top-2 right-2 bg-white p-2 rounded-full shadow-md hover:bg-red-50 transition-colors"
          title="Remove from wishlist"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            className="h-5 w-5 text-red-500"
            viewBox="0 0 20 20"
            fill="currentColor"
          >
            <path
              fillRule="evenodd"
              d="M3.172 5.172a4 4 0 015.656 0L10 6.343l1.172-1.171a4 4 0 115.656 5.656L10 17.657l-6.828-6.829a4 4 0 010-5.656z"
              clipRule="evenodd"
            />
          </svg>
        </button>
      </div>

      <div className="p-4 h-[50%]">
        <div className="flex flex-col gap-2 justify-between items-center h-full">
          <div className="h-full w-full">
            <h3 className="text-lg font-semibold text-gray-800 line-clamp-2">
              {product?.name}
            </h3>
            <p className="text-xl font-bold text-green-700">
              {product?.price} EGP
            </p>
            <p className="text-sm text-gray-600 line-clamp-2 h-10">
              {product?.description}
            </p>
            <Link
              to={`/product/${item.productId}`}
              className="text-[#DA0E1A] hover:text-red-700 font-medium text-center w-full block"
            >
              View Details
            </Link>
          </div>
          <button
            onClick={() => handleCartAction(item?.productId)}
            className="w-full bg-[#DA0E1A] text-white py-2 rounded hover:bg-red-700 transition-colors"
          >
            {isInCart(item.productId) ? "Remove from Cart" : "Add to Cart"}
          </button>
        </div>
      </div>
    </div>
  );
}

export default WishListCard;
